var _rect, _path, _path2, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerInnovativeJourney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 62,
    height: 62,
    rx: 16,
    stroke: "#DADADA",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 26V46",
    stroke: "url(#partnerIjGradient)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 26V38C50 43 46.5 47 41.5 47C38 47 35 45 33.5 42",
    stroke: "url(#partnerIjGradient)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 26,
    height: 4,
    rx: 2,
    fill: "#DADADA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "partnerIjGradient",
    x1: 22,
    y1: 26,
    x2: 50,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7948AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49B7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerInnovativeJourney);
export default __webpack_public_path__ + "static/media/partner_innovative_journey.10e88b58f47b9003f63087a08226c147.svg";
export { ForwardRef as ReactComponent };